<template>
  <div>
    <img src="../../assets/img/account-pages-placeholders/dashboard.jpg"
         alt="employees"
         style="width: 100%">
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    }
  }
</script>

<style lang="less">

</style>